import { FC, memo } from 'react';
import { ReactReduxContext, useSelector } from 'react-redux';
import { Stage as PixiStage } from '@inlet/react-pixi';
import useBackgroundLoad from 'hooks/useBackgroundLoad';
import usePersonsLoad from 'hooks/usePersonsLoad';
import { ContextBridge, BackgroundComponent, PersonComponent, PixiSpinner } from 'components';

import { getGlobal, getPersonsLoaded, getBGLoaded, getError, getSoundLoaded } from 'store';
import useSoundLoad from 'hooks/useSoundLoad';
import { BubbleWrapper } from '../BubbleWrapper';

type Props = {
  play: boolean;
};

export const Scene: FC<Props> = memo(({ play }) => {
  const { height, width } = useSelector(getGlobal);
  const isPersonsLoaded = useSelector(getPersonsLoaded);
  const isBGLoaded = useSelector(getBGLoaded);
  const isSoundLoaded = useSelector(getSoundLoaded);
  const isError = useSelector(getError);

  const personsSpritesList = usePersonsLoad();
  const bgSpritesList = useBackgroundLoad();
  useSoundLoad({ play });

  if (isError) {
    return (
      <div className="errorBlock" style={{ height, width }}>
        Something went wrong!
      </div>
    );
  }
  return (
    <ContextBridge
      Context={ReactReduxContext}
      render={(ch) => (
        <PixiStage
          height={height}
          width={width}
          options={{ resolution: window?.devicePixelRatio || 1 }}
        >
          {ch}
        </PixiStage>
      )}
    >
      {!isPersonsLoaded || !isBGLoaded || !isSoundLoaded ? (
        <PixiSpinner />
      ) : (
        <>
          <BackgroundComponent bgSpritesList={bgSpritesList} />
          <PersonComponent personsSpritesList={personsSpritesList} />
          {play ? <BubbleWrapper /> : null}
        </>
      )}
    </ContextBridge>
  );
});
